import { TextProcessConfig } from "@/API";
import { Button, Group, Modal, Stack, Switch } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function TextProcessConfigEditButton(props: { value?: TextProcessConfig, onChange?: (value: TextProcessConfig) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);

    const form = useForm<TextProcessConfig>({
        initialValues: props.value,

    });
    useEffect(() => {
        if (opened) {
            if (props.value) form.setValues(props.value)
            else form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="文字後處理">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values)
                close()
            })}>
                <Stack gap={5} mt={5}>
                    <Switch
                        label="強制去除Markdown"
                        {...form.getInputProps('forceRemoveMarkdown', { type: "checkbox" })}
                    />
                    <Switch
                        label="強制簡轉繁"
                        {...form.getInputProps('foreceHansToTW', { type: "checkbox" })}
                    />
                </Stack>
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}